// Centralized site configuration. Update values here to change globally.
const env = process.env;

export const site = {
  name: "HM Services",
  legalName: "HM Services",
  tagline: "Hospitality Consultancy & Digital Growth",
  domain: "thehmservices.com",
  url: "https://thehmservices.com",
  email: env.REACT_APP_CONTACT_EMAIL || "info.hassanalihms@gmail.com",
  // Configurable — button/links hidden automatically when empty.
  whatsapp: env.REACT_APP_WHATSAPP_NUMBER || "03317736808",
  phone: env.REACT_APP_PHONE_NUMBER || "03317736808",
  location: "Pakistan",
  founder: {
    name: "Hassan Ali",
    role: "Founder & Hospitality Consultant",
  },
  whatsappMessage:
    "Hello HM Services, I would like to discuss digital services for my property.",
  // Only rendered when a valid URL is set.
  social: {
    instagram: "https://www.instagram.com/hotel_management_service/",
    facebook: "https://www.facebook.com/share/18At2ThYwW/",
    linkedin: "",
    tiktok: "https://www.tiktok.com/@hotelmanagementservices",
    youtube: "",
  },
  analytics: {
    ga: env.REACT_APP_GA_ID || "",
    metaPixel: env.REACT_APP_META_PIXEL_ID || "",
  },
};

export const whatsappHref = (message) => {
  if (!site.whatsapp) return "";
  const digits = site.whatsapp.replace(/[^0-9]/g, "");
  const text = message || site.whatsappMessage;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
};

// Route-aware WhatsApp prefill messages.
const whatsappByPath = {
  "/services": "Hello HM Services, I'd like to discuss which digital services would suit my property.",
  "/packages": "Hello HM Services, I'm interested in one of your packages and would like a custom quote for my property.",
  "/list-your-property": "Hello HM Services, I'd like to list my property. Here are a few details about it:",
  "/process": "Hello HM Services, I'd like to start with a free property assessment for my property.",
  "/about": "Hello HM Services, I'd like to learn more about how you can help grow my property.",
  "/contact": "Hello HM Services, I'd like to get in touch about my property.",
};

export const whatsappMessageForPath = (pathname = "/") => {
  const key = Object.keys(whatsappByPath).find((p) => pathname.startsWith(p));
  return key ? whatsappByPath[key] : site.whatsappMessage;
};

export const mailtoHref = (subject = "Inquiry") =>
  `mailto:${site.email}?subject=${encodeURIComponent(subject)}`;
